import type { ReactNode } from 'react';

export const symbol_network_locked: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="m131-131 698-698q14-14 32.5-6.34Q880-827.69 880-808v306q0 12.75-8.68 21.37-8.67 8.63-21.5 8.63-12.82 0-21.32-8.63-8.5-8.62-8.5-21.37v-234L224-140h359q12.75 0 21.38 8.68 8.62 8.67 8.62 21.5 0 12.82-8.62 21.32Q595.75-80 583-80H152q-19.69 0-27.34-18.5Q117-117 131-131Zm584 51q-15 0-28.5-13.5T673-122v-122q0-15 13.5-28.5T715-286v-40q0-36 23.5-61t58.5-25q35 0 58 25t23 61v40h1q14 0 27.5 13.5T920-244v122q0 15-13.5 28.5T879-80H715Zm40-206h84v-40q0-19.55-11.5-32.77Q816-372 796.5-372T766-358.77q-11 13.22-11 32.77v40ZM224-140l596-596Q685.42-601.16 522-438T224-140Z"
		/>
	</svg>
);
